/**
 * Connectors Service — Report Templates API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportParameter { 
    name?: string;
    label?: string;
    type?: ReportParameter.TypeEnum;
    required?: boolean;
    defaultValue?: string;
}
export namespace ReportParameter {
    export const TypeEnum = {
        String: 'STRING',
        Number: 'NUMBER',
        Date: 'DATE',
        Timestamp: 'TIMESTAMP',
        Boolean: 'BOOLEAN'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


